import { createStore } from '@ngneat/elf';
import {
  deleteEntities,
  selectAllEntities,
  selectManyByPredicate,
  upsertEntities,
  withEntities
} from '@ngneat/elf-entities';
import { Injectable } from '@angular/core';

import { Dc3DiagramDataEntry, Dc3DiagramViewModel, JournalEntry } from './entry';
import * as dayjs from 'dayjs';
import { TimeFrame } from '../../tools/date';
import { map, Observable, switchMap } from 'rxjs';
import { TopicRepository, topicsObj$ } from '../topic/topic.repository';
// import {buildMock} from '../../tools/mock-builder';
import { windowDebug } from '../../tools/debug';
import { Tables } from '../database.types';
import { EntryWithTopic } from '../entry-with-topic';
import { Topic } from '../topic/topic';

const entryStore = createStore(
  {name: 'entries'},
  withEntities<JournalEntry>()
);

// const persistence = appPersistState(entryStore)

const addTopics = (source: Observable<JournalEntry[]>): Observable<EntryWithTopic[]> => {
  return source.pipe(switchMap(entries => topicsObj$.pipe(
    map(topics => entries.map(e => ({
      ...e,
      topic: topics[e.topic_id]
    })))
  )));
}

const sortByTopicOrder = (source: Observable<EntryWithTopic[]>): Observable<EntryWithTopic[]> => {
  return source.pipe(map(vms => {
    vms.sort((a, b) => {
      const valA = !!a.topic.order_number ? a.topic.order_number : 9999;
      const valB = !!b.topic.order_number ? b.topic.order_number : 9999;
      return valA - valB
    })
    return vms;
  }))
}

@Injectable({providedIn: 'root'})
export class EntryRepository {
  // private _tempEntriesSubject = new BehaviorSubject<Tables<'entries'>[]>([]);
  // tempEntries$ = this._tempEntriesSubject.asObservable();
  //
  // addTempEntry(topicId: number, date: string) {
  //   this._tempEntriesSubject.next([
  //     ...this._tempEntriesSubject.value,
  //     createEmptyEntry(topicId, date)
  //   ])
  // }
  //
  // removeTempEntry(topicId: number) {
  //   this._tempEntriesSubject.next([
  //     ...this._tempEntriesSubject.value.filter(entry => entry.topic_id !== topicId),
  //   ])
  // }



  entries$ = entryStore.pipe(
    selectAllEntities(),
    addTopics
  );

  constructor(private topicRepository: TopicRepository) {
    windowDebug('entryRepository', this);
    // persistence.initialized$.subscribe(initialized => {
    //   if (initialized) {
    //
    //     //todo implement temp entries when adding new!
    //     this.clearEmptyEntries();
    //
    //     // this.firebaseSyncService.registerStore({
    //     //   store: entryStore,
    //     //   fetchQueryConstraints$: this.fetchQueryConstraints$.asObservable()
    //     // });
    //   }
    // });
  }

  // setQueryConstraints(timeFrame: TimeFrame, topicId?: string) {
  //   const constraints = timeFrame.queryConstraints();
  //   if (topicId) {
  //     constraints.push(where('topicId', '==', topicId))
  //   }
  //   this.fetchQueryConstraints$.next(constraints);
  // }


  // async getBlogEntries(topicIds: string[], lastEntryId?: string): Promise<Dc3Entry[]> {
  //   const queryConstraints: QueryConstraint[] = []
  //   if (topicIds.length) {
  //     queryConstraints.push(where('topicId', 'in', topicIds))
  //   }
  //
  //   queryConstraints.push(orderBy('date', 'desc'));
  //
  //   if (lastEntryId) {
  //     const lastVisible = await this.firebaseSyncService.getDocumentSnapshotFor(entryStore.name, lastEntryId);
  //     queryConstraints.push(startAfter(lastVisible))
  //   }
  //
  //   queryConstraints.push(limit(10));
  //
  //   const q = query(
  //     this.firebaseSyncService.collectionRef(entryStore.name),
  //     ...queryConstraints
  //   );
  //
  //   const docs = await getDocs(q).then(docs => docs.docs)
  //   let entries = docs.map(doc => doc.data()) as Dc3Entry[];
  //   const topics = this.topicRepository.getTopicsObj();
  //   entries = entries.map(entry => {
  //     return {
  //       ...entry,
  //       topic: topics[entry.topicId]
  //     }
  //   });
  //   sortByDate(entries);
  //   return entries;
  // }

  // clearEmptyEntries() {
  //   entryStore.update(
  //     // // probably creates some junk datasets but is required for sync at moment
  //     updateEntitiesByPredicate(
  //       x => x.value === null && (x.content === null || x.content === ''),
  //       {removed: true, synced: false}
  //     ),
  //     updateEntitiesByPredicate(
  //       x => {
  //         //clear empty tracker entries
  //         const isTracker = !!this.topicRepository.getTopic(x.topicId)?.tracker?.range;
  //         const hasTrackerValue = x.value !== undefined;
  //         const hasEmptyContent = x.content === null || x.content === '';
  //
  //         return x.content !== null && isTracker && hasTrackerValue && hasEmptyContent;
  //       },
  //       {isFullEntry: false, synced: false}
  //     )
  //   );
  // }

  entriesByTimeFrame$(timeFrame: TimeFrame) {
    return entryStore.pipe(
      selectManyByPredicate(x =>
        dayjs(x.date).isBetween(
          timeFrame.startDate, timeFrame.endDate,
          'day', '[]'
        )
      ),
      addTopics,
      sortByTopicOrder
      // tap(x => console.log('checktopics', x)),
    );
  }

  getDiagramDataByRange$(timeFrame: TimeFrame): Observable<Dc3DiagramViewModel> {
    return entryStore.pipe(
      selectManyByPredicate(entry => timeFrame.isBetween(entry.date))
    )
      .pipe(
        addTopics,
        sortByTopicOrder,
        map(entries => {
          let topics: Topic[] = []
          let diagramData: Dc3DiagramDataEntry[] = []

          entries
            .filter(entry => entry.value)
            .forEach(entry => {

              if (!topics.some(x => x.id === entry.topic_id)) {
                topics.push(entry.topic);
              }
            });

          const diagramDateFormat = 'ddd DD.MM.'

          diagramData.push({
            name: '-',
            color: 'transparent',
            series: timeFrame.days.map(day => ({
              name: dayjs(day).format(diagramDateFormat),
              value: 0
            }))
          } as any)

          topics.forEach(topic => {
            diagramData.push({
              topicId: topic.id,
              name: topic.name,
              color: topic.color,
              series: entries
                .filter(entry => entry.topic_id === topic.id && entry.value)
                .map(entry => ({
                  name: dayjs(entry.date).format(diagramDateFormat),
                  value: entry.value! * 10
                }))
            })
          });

          const topicColors = topics.map(x => ({name: x.name, value: x.color}))

          return {
            data: diagramData,
            customColors: [
              ...topicColors,
              {name: '-', value: 'transparent'}
            ]
          };
        })
      )
  }

  getEntriesByDate$(date: string): Observable<JournalEntry[]> {
    return entryStore.pipe(
      selectManyByPredicate(x => dayjs(x.date).isSame(date, 'day'))
      // addTopics,
      // sortByTopicOrder
    )
  }

  // getEntriesByTopic$(topic: Dc3Topic): Observable<Dc3Entry[]> {
  //   return entryStore.pipe(
  //     selectManyByPredicate(x => !x.removed && x.topicId === topic.id),
  //     map(x => x.map(entry => ({...entry, topic})))
  //   );
  // }


  upsertEntries(entries: JournalEntry[]) {

    entryStore.update(
      upsertEntities(entries)
    )
  }

  deleteEntries(ids: number[]) {
    // const deleteEntries =
    //   entries.map(entry => ({...entry, removed: true}));
    entryStore.update(deleteEntities(ids))
  }

  //danger this will blow bundle size... create seperate tool for this
  // setMockData() {
  //   const mock = buildMock();
  //   console.log(mock);
  //   this.topicRepository.upsertTopics(mock.topics);
  //   this.upsertEntries(mock.entries);
  // }
  reset() {
    entryStore.reset();
  }
}
